import React from 'react';
import PropTypes from 'prop-types';
import { IonImg, IonAvatar, IonIcon } from '@ionic/react';
import { restaurantOutline } from 'ionicons/icons';

function VenueLogo({ logo }) {
  return logo ? (
    <IonAvatar slot="start">
      <IonImg src={logo} />
    </IonAvatar>
  ) : (
    <IonAvatar slot="start" className="venue-thumbnail">
      <IonIcon icon={restaurantOutline} />
    </IonAvatar>
  );
}

VenueLogo.propTypes = {
  logo: PropTypes.string,
};

export default VenueLogo;
